var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('layout-header'),_c('layout-notification'),_c('div',{staticStyle:{"min-height":"calc(100vh - 283px)"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in","duration":10}},[_c('router-view')],1)],1),_c('layout-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }